module.exports = __webpack_public_path__ + "static/media/enhanced.1a11af64.png";